export default __webpack_public_path__ + "static/media/Login_2.a7dec8dc.png";